let isWebpSupported = false;
let isAvifSupported = false;

export async function init(
  forceIsWebpSupported?: boolean,
  forceIsAvifSupported?: boolean
) {
  // テスト用
  if (
    forceIsWebpSupported !== undefined &&
    forceIsAvifSupported !== undefined
  ) {
    isWebpSupported = forceIsWebpSupported;
    isAvifSupported = forceIsAvifSupported;
    return;
  }
  // webpをサポートしているかどうかを判定する
  isWebpSupported = await (async (): Promise<boolean> => {
    return await new Promise(resolve => {
      const image = new Image();
      image.onerror = () => {
        resolve(false);
      };
      image.onload = () => {
        resolve(true);
      };
      image.src =
        "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=";
    });
  })();

  // avifをサポートしているかどうかを判定する
  isAvifSupported = await (async (): Promise<boolean> => {
    return await new Promise(resolve => {
      const image = new Image();
      image.onerror = () => {
        resolve(false);
      };
      image.onload = () => {
        resolve(true);
      };
      image.src =
        "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";
    });
  })();
}

// ブラウザに最適な画像を取得する
export function getOptimizedImageUrl(
  url: string | null,
  width: number | null,
  height: number | null
) {
  if (!url) return null;

  const params = [];
  if (isAvifSupported) {
    params.push(`f=avif`);
  } else if (isWebpSupported) {
    params.push(`f=webp`);
  } else {
    params.push(`f=jpg`);
  }
  if (width) params.push(`w=${width}`);
  if (height) params.push(`h=${height}`);

  let joinChar = "?";
  if (url.includes("?")) {
    joinChar = "&";
  }
  return `${url}${joinChar}${params.join("&")}`;
}

// データURIかどうかを判定する
export function isDataUri(str: string | null | undefined): boolean {
  return !!str && str.startsWith("data:");
}
